import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiControllerGetExchanges: build.query<
      ApiControllerGetExchangesApiResponse,
      ApiControllerGetExchangesApiArg
    >({
      query: (queryArg) => ({
        url: `/web/exchanges/${queryArg.blockchainId}`,
        params: {
          cl: queryArg.cl,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ApiControllerGetExchangesApiResponse =
  /** status 200 Returns exchanges for given blockchain */ ExchangesResponse;
export type ApiControllerGetExchangesApiArg = {
  /** Blockchain ID (0 = all active blockchains) */
  blockchainId: number;
  /** If 1 — return only concentrated-liquidity capable exchanges (e_cl=1) */
  cl?: number;
};
export type ExchangeItem = {
  id: number;
  name: string;
  bId?: number;
  protocol?: string;
  fee?: string;
  service?: number;
  handler?: string;
  router?: string;
  factory?: string;
  /** NonfungiblePositionManager (required for CL) */
  nftManager?: string;
  poolDeployer?: string;
  /** Swap-wallet Solidity template name */
  contractTemplate?: string;
  /** Concentrated-liquidity wallet Solidity template name */
  clContractTemplate?: string;
  /** 1 = exchange supports concentrated liquidity (tick-based positions) */
  cl?: number;
};
export type ExchangesResponse = {
  /** Operation status */
  status: boolean;
  data: ExchangeItem[];
};
